import React, { useState } from "react";
import { motion } from "framer-motion";
import Profilemenu from "../Profile_menu/Profilemenu";
import { SVGIcons } from "../../Helpers/Common";
import { Metadata } from "../Metadata/Metadata";
import { Link } from "react-router-dom";

var SVGIcon = "";
SVGIcons().then((resultData) => (SVGIcon = resultData));

export default function AboutusMobile() {

  const { VirsionCheckData, userData } = useState();

  return (
    <>
      <motion.div
        className=""
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        exit={{ opacity: 0 }}
        transition={{ duration: 1 }}
        key="1"
      >
        <Metadata page="ABOUT-US" />
        <main>
          <div className="webviewpages mobilewebview setting-main">
            <header>
              <div className="profile-back-desk dD-block">
                <Link to="/">
                  <div className="docubayBack white">
                    <img src={SVGIcon["back.svg"]} alt="DocuBay" />
                  </div>
                </Link>
              </div>
            </header>
            <section className="mb-0">
              <div className="homeBanner">
                <div className="innerBanner mb-0">
                  <div className="policy-title">
                    <h1>About <span className="red"> us</span></h1>
                  </div>
                </div>
              </div>
            </section>
            <section>
              <div className="temp37">
                <div className="temp37-inn">
                  <p>
                    Headquartered in Mumbai, the financial capital of world’s largest internet market, DocuBay is a global
                    membership video-on-demand platform designed specifically for streaming documentaries from around
                    the world. Developed to cater to factual entertainment viewers, the platform offers mainstream, engaging,
                    relevant and insightful content across genres from leading creators across the globe.
                  </p>
                  <p>
                    With One Tribe, Many Stories as the brand’s tagline, DocuBay brings together real stories from around the
                    globe for its viewers to stream. DocuBay is available across all devices and is accessible in more than 150
                    countries, with its team spread between US, UK, Europe and Asia. Viewers can become a member to enjoy
                    premium documentaries with Monthly, Quarterly & Yearly Plans. DocuBay also offers a FAST Channel.
                  </p>
                  <p>
                    DocuBay is a part of IN10 Media Network, a company with a plethora of offerings across the media and
                    entertainment sector. Led by entrepreneur Aditya Pittie, IN10 Media Network has its efforts focused on
                    building world-class brands that are the epitome of quality content.
                  </p>
                </div>
              </div>
            </section>
            <div className="dD-block">
              <Profilemenu versioncheck={VirsionCheckData} profile={userData} />
            </div>
          </div>
        </main>
      </motion.div>
    </>
  );
}